import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    totalTabs: Number,
    currentTabIndex: Number,
  };

  static targets = ["nextButton"];

  currentTabIndexValueChanged() {
    this.nextButtonTarget.disabled =
      this.currentTabIndexValue + 1 === this.totalTabsValue;
  }

  setCurrentTabIndex(event) {
    this.currentTabIndexValue = event.detail.currentIndex;
  }
}
